import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {RouteTypename} from '@src/Navigation/types/route.type';
import useDownloadCertificate from './useDownloadCertificate';
import {useCurrentLanguage} from '~Store/Slices/LanguageSlice/Language.selector';
import DownloadButton from 'design-system/src/Components/DownloadButton/DownloadButton';
import {toast} from 'react-toastify';
import useBreakpoint from 'design-system/src/WebComponent/Grid/hooks/useBreakpoint';
export interface IDownloadCertButtonProps {
  id: string;
  __typename: RouteTypename;
  name?: string;
  label?: string;
}

const DownloadCertButton = (props: IDownloadCertButtonProps) => {
  const {id, __typename, name, label} = props;
  const {t} = useTranslation('profile');
  const currentLanguage = useCurrentLanguage();
  const {isMobile} = useBreakpoint();

  const [downloadCert, {resetProgress}, progress] = useDownloadCertificate();

  const handleDownload = useCallback(
    async (id: string, __typename: RouteTypename, filename?: string) => {
      try {
        await downloadCert({
          id,
          culture: currentLanguage,
          isCourse: __typename === 'Course',
          filename,
        });
        setTimeout(() => {
          resetProgress();
        }, 8000);
      } catch (error) {
        console.error('File download error:', error);
        toast.error(t('Unable to download certificate'));
      }
    },
    [currentLanguage, downloadCert, t],
  );

  return (
    <div style={{display: 'flex', alignItems: 'center'}}>
      <DownloadButton
        label={isMobile ? label : ''}
        onDownload={() => handleDownload(id, __typename, name)}
        progress={progress}
        customStyle={{
          width: 'auto',
        }}
      />
    </div>
  );
};

export default DownloadCertButton;
